import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { routeAnimations } from './app.animations';
import { Subscription, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { LoadSessions, LogoutSessionsSuccess, InitializeSessions } from './state/session.actions';
import { CoreState, Session } from './state/_state.interfaces';
import { getLoading, getSession, getOpenSideNav } from './state/_state.selectors';
import { map } from 'rxjs/operators';
import { CloseSideNav } from './state/nav.actions';
import { LoadingService } from './services/loading.service';

/**
 * Appコンポーネント
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    routeAnimations
  ]
})
export class AppComponent implements OnInit, OnDestroy {

  private routerSub: Subscription;

  public loading$: Observable<boolean>;

  public session$: Observable<Session>;
  public sideNavOpened$: Observable<boolean>;
  public islogin$: Observable<boolean>;
  public showNavbar$: Observable<boolean>;

  constructor(
    private router: Router,
    private session: Store<CoreState>,
    private loadService: LoadingService
  ) {
    // アプリのIDを付与する
    this.session.dispatch(new InitializeSessions());

    // ログイン画面以外の場合はロード処理を行う
    if (location.hash !== '' && location.hash !== '#/login') {
      this.session.dispatch(new LoadSessions());
    } else {
      // ログイン画面でアプリを起動した場合はステートをすべてクリアする
      this.session.dispatch(new LogoutSessionsSuccess());
    }

    // ローダーを設定
    this.loading$ = this.loadService.loading$;
    this.loadService.addLoader('session', this.session.select(getLoading));

    this.session$ = this.session.select(getSession);
    this.sideNavOpened$ = this.session.select(getOpenSideNav);

    // ログイン状態
    this.islogin$ = this.session.select(getSession).pipe(map(store => store.login));
  }

  ngOnInit(): void {
    history.pushState(null, null, null);
    // ブラウザバック禁止-1(ナビゲーション終了のタイミングでhistoryに空をセット)
    this.routerSub = this.router.events.subscribe(
      (evt) => {
        if (evt instanceof NavigationEnd) {
          history.pushState(null, null, null);
        }
      }
    );
    // ブラウザバック禁止-2(バックボタンを押したときにhistoryに空をセット)
    window.addEventListener('popstate', function() {
        history.pushState(null, null, null);
    });
  }

  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  closeNav() {
    this.session.dispatch(new CloseSideNav());
  }

  ShowNavbar(): boolean {
    if (this.router.url === '/login' || this.router.url === '/portal' || this.router.url === '/wd/kpi' || this.router.url === '/wd2c/kpi' || this.router.url === '/logi-kpi/compare-brands'){
      return false;
    }else{
      return true;
    }
  }
}
